/**
 * The one absolute-date format this page uses, shared by the freshness pill and the
 * skipped-provider warning so a publish time reads identically wherever it appears.
 *
 * Built by hand rather than through `toLocaleDateString`, because the ICU data behind that call
 * varies between a reviewer's browser and CI (`en-GB` abbreviates September as "Sept" in recent
 * CLDR, "Sep" in older). A publish date is evidence, and evidence that changes shape between
 * machines is not worth the ambiguity.
 */
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** `19 Sep 2026`, in the reviewer's local time zone. */
export function formatPublishedDate(date: Date | undefined): string | undefined {
  if (!date) return undefined;
  return `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}
